import { render, staticRenderFns } from "./FamilyInfo.vue?vue&type=template&id=11563619&scoped=true"
import script from "./FamilyInfo.vue?vue&type=script&lang=js"
export * from "./FamilyInfo.vue?vue&type=script&lang=js"
import style0 from "./FamilyInfo.vue?vue&type=style&index=0&id=11563619&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11563619",
  null
  
)

export default component.exports